import type { Meta, StoryObj } from "@storybook/react";

import type { ProviderCarouselCardProps } from "@/ui/components/profile";
import { ProviderCarouselCard } from "@/ui/components/profile";

const StoryMeta: Meta<ProviderCarouselCardProps> = {
  title: "Components/Profile/Provider Carousel Card",
  component: ProviderCarouselCard,
  argTypes: {
    fullName: { control: "text" },
    pronouns: { control: "object" },
    providerTypeName: { control: "text" },
  },
  args: {
    fullName: "Christine Loreto",
    pronouns: ["(she/her)"],
    providerTypeName: "Therapist, LSW",
  },
};

type Story = StoryObj<ProviderCarouselCardProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
